import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import EntityStateForm, {EntityStateFormProps} from "../../../pages/administration/entities/components/EntityStateForm";
import {modalClose} from "../genericFunctions";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, EntityStateFormProps {
}

type Props = OwnProps;

// @ts-ignore
const EntityStateModal = NiceModal.create<Props>(({entityState, entityId, onClose, header}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <EntityStateForm entityState={entityState} entityId={entityId}/>
        </SlideOver>
    )
})

export default EntityStateModal;
